<template>
  <v-dialog
      v-model="dialog"
      max-width="500"
    >
    <template v-slot:activator="{ on }">
      <v-btn
        color="green lighten-2"
        dark
        v-on="on"
      >
        Add Book
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Add book
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="title"
          label="Title"
          required
        ></v-text-field>
        <v-text-field
          v-model="author"
          label="Author"
        ></v-text-field>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="createBook"
        >
          Add book
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'AddBook',
  data () {
    return {
      title: '',
      author: '',
      dialog: false
    }
  },
  methods: {
    createBook (book) {
      this.$emit('createbook', {
        title: this.title,
        author: this.author
      })
      this.dialog = false
    }
  }
}
</script>
